module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "SOM"
  }, [_c('div', {
    staticClass: "SOM_titre"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("General preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("Author’s preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4"
    }
  }, [_vm._v("Chief abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6"
    }
  }, [_vm._v("Further reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre7"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre7#niv1-001"
    }
  }, [_vm._v("Isaiah’s message")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre7#niv2-001"
    }
  }, [_vm._v("(a) Isaiah 1 ‒ 5")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre7#niv2-002"
    }
  }, [_vm._v("(b) Isaiah 6 ‒ 12")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre7#niv2-003"
    }
  }, [_vm._v("(c) Isaiah 13 ‒ 27")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre7#niv2-004"
    }
  }, [_vm._v("(d) Isaiah 28 ‒ 37")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre7#niv2-005"
    }
  }, [_vm._v("(e) Isaiah 38 ‒ 55")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre7#niv2-006"
    }
  }, [_vm._v("(f) Isaiah 56 ‒ 66")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre7#niv1-002"
    }
  }, [_vm._v("Isaiah’s thought")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre7#niv2-007"
    }
  }, [_vm._v("(a) History and faith")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre7#niv2-008"
    }
  }, [_vm._v("(b) Faith waiting")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre7#niv1-003"
    }
  }, [_vm._v("Isaiah’s book")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre7#niv2-009"
    }
  }, [_vm._v("(a) Recovery of unity")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre7#niv2-010"
    }
  }, [_vm._v("(b) Models of growth")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre7#niv2-011"
    }
  }, [_vm._v("(c) Arguments and evaluations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre7#niv2-012"
    }
  }, [_vm._v("(b) An ‘Isaiah’ scenario")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre7#niv1-004"
    }
  }, [_vm._v("Text")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre7#niv1-005"
    }
  }, [_vm._v("Isaiah and the New Testament")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre8"
    }
  }, [_vm._v("Analysis")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/p1sp1chap1#part-001"
    }
  }, [_vm._v("Commentary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_spart"
  }, [_c('a', {
    attrs: {
      "href": "#/p1sp1chap1#spart-001"
    }
  }, [_vm._v("The book of the King (1 – 37)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1sp1chap1"
    }
  }, [_vm._v("1. Backdrop to the ministry of Isaiah: the author’s preface (1 ‒ 5)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p1sp1chap1#niv1-006"
    }
  }, [_vm._v("a. Heading (1:1)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p1sp1chap1#niv1-007"
    }
  }, [_vm._v("b. A comprehensive failure (1:2‒31)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p1sp1chap1#niv1-008"
    }
  }, [_vm._v("c. The ideal, lost and found (2:1 ‒ 4:6)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/p1sp1chap1#niv1-009"
    }
  }, [_vm._v("d. Grace exhausted (5:1‒30)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp1chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Light beyond the darkness: the coming King (6 ‒ 12)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp1chap2#niv1-010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. The individual, atonement and commission (6:1‒13)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp1chap2#niv1-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Darkness and light in Judah (7:1 ‒ 9:7)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp1chap2#niv1-012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Additional note on the term ‘virgin’ in Isaiah 7:14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp1chap2#niv1-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Darkness and light in Israel (9:8 ‒ 11:16)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp1chap2#niv1-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. The individual in the community – salvation, singing and proclamation (12:1‒6)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp1chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The kingdom panorama: the whole world in his hand (13 ‒ 27)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp1chap3#niv1-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. The first series of oracles: sure promises (13:1 ‒ 20:6)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp1chap3#niv1-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. The second series of oracles: the long night and the dawn (21 ‒ 23)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp1chap3#niv1-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. The third series: The world city and the city of God (24:1 ‒ 27:13)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp1chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Lord of history (28 ‒ 37)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp1chap4#niv1-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. The six woes (28:1 ‒ 35:10)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp1chap4#niv1-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Epilogue: the rock of history (36:1 ‒ 37:38)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_spart"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap1#spart-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The book of the Servant (38 – 55)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Hezekiah and the way of faith: the decisive sin (38 ‒ 3 9)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap1#niv1-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. One prayer, two answers (38:1‒8)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap1#niv1-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Death and life (38:9‒22)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap1#niv1-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Additional note on the ‘intrusive’ narrative at Isaiah 38:21‒22")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap1#niv1-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. The moment of decision (39:1‒8)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Universal consolation (40:1 ‒ 42:17)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap2#niv1-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Consolation for the Lord’s people (40:1 ‒ 41:20)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap2#niv1-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Gentile hope (41:21 ‒ 42:17)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Lord’s plan unfolded (42:18 ‒ 44:23)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap3#niv1-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Israel’s bondage and liberation (42:18 ‒ 43:21)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap3#niv1-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Israel’s sin and redemption (43:22 ‒ 44:23)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The great deliverance: the work of Cyrus (44:24 ‒ 48:22)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap4#niv1-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Cyrus: builder and conqueror (44:24 ‒ 45:8)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap4#niv1-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Additional note on the prediction of Cyrus in 44:28")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap4#niv1-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Rebellion and resolve, quibbling and consolation (45:9 ‒ 46:13)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap4#niv1-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Free at last (47:1 ‒ 48:22)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The greater deliverance: the work of the Servant (49 ‒ 55)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap5#niv1-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. The Servant’s double task (49:1‒6)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap5#niv1-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Divine confirmation: worldwide success (49:7‒13)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap5#niv1-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Nation and Servant, a contrast: unresponding and responding (49:14 ‒ 50:11)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap5#niv1-035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. Salvation in prospect: the watching remnant (51:1 ‒ 52:12)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp2chap5#niv1-036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e. Worldwide salvation (52:13 ‒ 55:13)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_spart"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3dev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The book of the Conqueror (56 – 66)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The ideal and the actual: the Lord’s needy, under-achieving people (56:1 ‒ 59:13)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap2#niv1-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. The waiting people (56:1‒8)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap2#niv1-038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. The divided people (56:9 ‒ 57:21)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap2#niv1-039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. The Sabbath people (58:1‒14)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap2#niv1-040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. The guilty people (59:1‒13)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The promised Conqueror: vengeance and salvation (59:14 ‒ 63:6)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap3#niv1-041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Preface: situation and remedy (59:14‒20)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap3#niv1-042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. The Covenant Mediator and his achievement (59:21 ‒ 60:22)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap3#niv1-043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. The Anointed One and his transforming work (61:1‒9)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap3#niv1-044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. The Saviour and his gathered people (61:10 ‒ 62:12)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap3#niv1-045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e. The consummation: the Anointed One completes his task (63:1‒6)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The new heaven and new earth: prayers and promises (63:7 ‒ 66:24)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap4#niv1-046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. A ‘remembrancer’ at prayer (63:7 ‒ 64:12)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1sp3chap4#niv1-047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. The Lord responding: sure promises, coming consummation (65:1 ‒ 66:24)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for Tyndale Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tyndale Commentary Volumes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/ident12#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0